import { observable, action } from "mobx";
import { ModelItem, sportItemType } from "../../../common";

export type SportData = {
    id : string;
    order: number;
    name : string;
    numberOfEvents: number;
}

export class SportModel implements ModelItem {

    id : string;
    order: number;
    name : string;
    type: sportItemType;
    @observable
    numberOfEvents: number;

    constructor(sport: SportData, type: sportItemType = "sports") {
        this.id = sport.id;
        this.order = sport.order;
        this.name = sport.name;
        this.numberOfEvents = sport.numberOfEvents;
        this.type = type;
    }

    @action.bound update(newItem: Partial<SportModel>): void {
        newItem.id && (this.id = newItem.id);
        newItem.order && (this.order = newItem.order);
        newItem.name && (this.name = newItem.name);
        newItem.numberOfEvents && (this.numberOfEvents = newItem.numberOfEvents);
        newItem.type && (this.type = newItem.type);
    }
}
